// Group GROUP 19. Advanced Combinations
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group19Data = {
  "id": "group_19",
  "title": {
    "tc": "高階組合",
    "sc": "高阶组合",
    "en": "Advanced Combinations"
  },
  "subtitle": {
    "tc": "Advanced Combinations",
    "sc": "Advanced Combinations",
    "en": "Advanced Combinations"
  },
  "icon": "🎯",
  "difficulty": "advanced",
  "color": "from-purple-500 to-purple-600",
  "topics": [
    {
      "id": "it_cleft_adverbial",
      "title": {
        "tc": "It-cleft 焦點在狀語",
        "sc": "It-cleft 焦点在状语",
        "en": "It-cleft (Adverbial Focus)"
      },
      "description": {
        "tc": "學習 It-cleft 結構中狀語焦點的用法",
        "sc": "学习 It-cleft 结构中状语焦点的用法",
        "en": "Learn It-cleft structures with adverbial focus"
      },
      "icon": "🎯",
      "difficulty": "advanced",
      "examples": [
        {
          "id": "it_cleft_adv_1",
          "sentence": "It was yesterday that he arrived.",
          "analysis": "It (dummy) was (V) yesterday (focus-M) <that> [he (S) arrived (V)].",
          "translation": {
            "tc": "他是昨天到達的。",
            "sc": "他是昨天到达的。",
            "en": "It was yesterday that he arrived."
          }
        },
        {
          "id": "it_cleft_adv_2",
          "sentence": "It was in 2010 that they met.",
          "analysis": "It (dummy) was (V) in 2010 (focus-M) <that> [they met].",
          "translation": {
            "tc": "他們是在2010年相遇的。",
            "sc": "他们是在2010年相遇的。",
            "en": "It was in 2010 that they met."
          }
        },
        {
          "id": "it_cleft_adv_3",
          "sentence": "It was here that we first spoke.",
          "analysis": "It (dummy) was (V) here (focus-M) <that> [we first spoke].",
          "translation": {
            "tc": "我們是在這裡第一次說話的。",
            "sc": "我们是在这里第一次说话的。",
            "en": "It was here that we first spoke."
          }
        },
        {
          "id": "it_cleft_adv_4",
          "sentence": "It was because of luck that we won.",
          "analysis": "It (dummy) was (V) because of luck (focus-M) <that> [we won].",
          "translation": {
            "tc": "我們是因為運氣才贏的。",
            "sc": "我们是因为运气才赢的。",
            "en": "It was because of luck that we won."
          }
        },
        {
          "id": "it_cleft_adv_5",
          "sentence": "It is with great pleasure that I announce…",
          "analysis": "It (dummy) is (V) with great pleasure (focus-M) <that> [I announce …].",
          "translation": {
            "tc": "我很高興地宣布…",
            "sc": "我很高兴地宣布…",
            "en": "It is with great pleasure that I announce…"
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：強調時間/地點/原因等狀語；演講/正式文本常用。",
        "sc": "要点：强调时间/地点/原因等状语；演讲/正式文本常用。",
        "en": "Key points: emphasizes time/place/reason adverbials; common in speeches/formal texts."
      }
    }
  ]
};
